import { css } from '@linaria/core';

import { TILE_HEIGHT, TILE_WIDTH } from ':cloud/widgets/buildQuest/constants';

const centeredStarCoordinates = { x: TILE_WIDTH / 2 - 40, y: TILE_HEIGHT / 2 - 40 };
export const starStyles = css`
  transform: translate(${centeredStarCoordinates.x}px, ${centeredStarCoordinates.y}px);
`;

export const starPath =
  'M40 0L48.2333 31.7667L80 40L48.2333 48.2333L40 80L31.7667 48.2333L0 40L31.7667 31.7667L40 0Z';
